'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeCart = function (_React$Component) {
    _inherits(PromizeCart, _React$Component);

    function PromizeCart(props) {
        _classCallCheck(this, PromizeCart);

        var _this = _possibleConstructorReturn(this, (PromizeCart.__proto__ || Object.getPrototypeOf(PromizeCart)).call(this, props));

        _this.pzGetUploadImage = function (uploadedFile) {
            return new Promise(function (resolve, reject) {
                var fileReader = new FileReader();
                fileReader.onload = async function (event) {
                    var image = await _this.pzDownloadImageByUrl(event.target.result);
                    resolve(image);
                };
                fileReader.onerror = function (event) {
                    reject(function () {
                        console.error('Error on reading the file: ' + error);
                    });
                };
                fileReader.readAsDataURL(uploadedFile);
            });
        };

        _this.pzDownloadImageByUrl = function (url) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.addEventListener('load', function (e) {
                    return resolve(img);
                });
                img.addEventListener('error', function () {
                    return reject(new Error('Failed to load image from URL: ' + url));
                });
                img.src = url;
            });
        };

        _this.pzDownloadHandlerOLD = async function () {
            var download = document.getElementById('download');
            var positions = [{ x: 120, y: 10, z: -12 }, { x: -120, y: 10, z: 5 }];
            var canvasDataUrl = await _this.props.promizeThreeDObj.getView(positions);
            var viewName = ['Front', 'Back'];

            if (canvasDataUrl && canvasDataUrl.length > 0) {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                ctx.globalAlpha = 0;

                var blob = await fetch(_this.props.pzIconsPath + "Wristbands.com_Logo_Final_500px_black.png").then(function (r) {
                    return r.blob();
                });
                var logo = await _this.pzGetUploadImage(blob);

                /* loop through images */
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = canvasDataUrl.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            i = _step$value[0],
                            url = _step$value[1];

                        var image = await _this.pzDownloadImageByUrl(url);
                        var imgHalfWidth = image.height * (50 / 296);
                        var imgWidth = imgHalfWidth * 2;
                        var logoWidth = image.height * (110 / 296);
                        var logoHeight = logoWidth * (logo.height / logo.width);
                        var logoPadding = image.height * (10 / 296);
                        var imagePadding = image.height * (100 / 296);
                        var imagePosX = imagePadding * (i + 1) + imgWidth * i;
                        var imagePosY = 0 + logoHeight + logoPadding;
                        var imageClipX = image.width / 2 - imgHalfWidth;
                        var imageClipY = 0;
                        var fontSize = image.height * (20 / 296);
                        var fontPosX = imagePosX + imgHalfWidth;
                        var fontPosY = image.height + logoHeight + logoPadding + fontSize * 1.5;

                        if (i == 0) {
                            /* set canvas dimension */
                            canvas.width = imgWidth * 2 + imagePadding * 3;
                            canvas.height = image.height + fontSize * 3 + logoHeight + logoPadding;

                            /* set background color */
                            var gradient = ctx.createRadialGradient(canvas.width / 2, canvas.height / 2, 0, canvas.width / 2, canvas.height / 2, canvas.width / 2);
                            gradient.addColorStop(0, '#f5f5f5');
                            gradient.addColorStop(1, '#d6d6d6');
                            ctx.fillStyle = gradient;
                            ctx.fillRect(0, 0, canvas.width, canvas.height);

                            /* set logo */
                            ctx.drawImage(logo, logoPadding, logoPadding, logoWidth, logoHeight);
                        }
                        /* set text */
                        ctx.font = 'bolder ' + fontSize + 'px Roboto';
                        ctx.textAlign = "center";
                        ctx.fillStyle = "black";
                        ctx.fillText(viewName[i], fontPosX, fontPosY);

                        /* set image */
                        ctx.drawImage(image, imageClipX, imageClipY, imgWidth, image.height, imagePosX, imagePosY, imgWidth, image.height);
                    }

                    /* create watermark */
                    /* multiple */
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var waterMarkLogo = await _this.pzDownloadImageByUrl(_this.props.pzIconsPath + "logo-black_normal.png");
                var xCount = canvas.width / waterMarkLogo.width + 1;
                var yCount = canvas.height / waterMarkLogo.height + 1;
                ctx.globalAlpha = 0.2;
                for (var yIndex = 0; yIndex < yCount; yIndex++) {
                    for (var xIndex = 0; xIndex < xCount; xIndex++) {
                        ctx.drawImage(waterMarkLogo, waterMarkLogo.width * xIndex * 2, waterMarkLogo.width * yIndex);
                    }
                }

                /* download image */
                download.href = canvas.toDataURL("image/png");
                download.click();
            }
        };

        _this.pzDownloadHandler = async function () {
            /* init variables */
            var viewNames = ['Front', 'Back'];
            var wallUrl = _this.props.pzIconsPath + 'wall.jpg';
            var girlUrl = _this.props.pzIconsPath + 'girl-modified.png';
            var maskUrl = _this.props.pzIconsPath + 'girl-mask.png';
            var logoUrl = _this.props.pzIconsPath + 'Wristbands.com_Logo_Final_500px_black.png';
            var watermarkUrl = _this.props.pzIconsPath + 'logo-black_normal.png';
            if (_this.props.pzCustomizer.product.domain_id != 751 && _this.props.pzCustomizer.product.domain_id != 681) {
                logoUrl = _this.props.pzIconsPath + 'logo_color.png';
                watermarkUrl = _this.props.pzIconsPath + 'logo_black.png';
            }
            var canvasDataUrl = await _this.props.promizeThreeDObj.getView([{ x: 120, y: 10, z: -12 }, { x: -120, y: 10, z: 5 }]);
            var download = document.getElementById('download');

            if (canvasDataUrl && canvasDataUrl.length > 0) {
                /* download images */
                var logo = await _this.pzDownloadImageByUrl(logoUrl);
                var mask = await _this.pzDownloadImageByUrl(maskUrl);
                var girl = await _this.pzDownloadImageByUrl(girlUrl);
                var wall = await _this.pzDownloadImageByUrl(wallUrl);
                var watermark = await _this.pzDownloadImageByUrl(watermarkUrl);

                /* init canvas */
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                ctx.globalAlpha = 0;

                var imgHeight = 0;

                /* loop through images */
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = canvasDataUrl.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _step2$value = _slicedToArray(_step2.value, 2),
                            i = _step2$value[0],
                            url = _step2$value[1];

                        /* tag variables */
                        var image = await _this.pzDownloadImageByUrl(url);
                        imgHeight = image.height;
                        var imgHalfWidth = imgHeight * (172.97297297297297 / 1024);
                        var imgWidth = imgHalfWidth * 2;
                        var imagePaddingX = imgHeight * (221.40540540540542 / 1024);
                        var imagePaddingY = imgHeight * (242.16216216216216 / 1024);
                        var imagePosX = imagePaddingX;
                        var imagePosY = imagePaddingY;
                        var imageClipX = image.width / 2 - imgHalfWidth;
                        var imageClipY = 0;
                        var imageScaleX = imgHeight * (217.39130434781944 / 1024);
                        var imageScaleY = imgHeight * (643.4782608695456 / 1024);

                        /* girl variables */
                        var girlWidth = 864.8648648648649;
                        var girlHeight = 1536;
                        var girlPaddingX = imgHeight * (51.891891891891895 / 1024);
                        var girlPosX = girlPaddingX;
                        var girlPosY = 0;
                        var girlClipX = 622.7027027027027;
                        var girlClipY = 0;
                        var girlScaleX = imgHeight * (581.3953488372093 / 1024);
                        var girlScaleY = imgHeight * (1032.5581395348838 / 1024);

                        /* circle variables */
                        var circleX = imgHeight * (1113.0434782608697 / 1024);
                        var circleY = imgHeight * (553.5135135135134 / 1024);
                        var circleRadius = imgHeight * (445.21739130434787 / 1024);

                        /* font variables */
                       /* var fontSize = imgHeight * (40 / 1024);
                        var fontPosX = i === 0 ? imgHeight * (935.1598173515982 / 1024) : imgHeight * (1285.12 / 1024);
                        var fontPosY = imgHeight * (914.2857142857142 / 1024);*/

                        let fontSize = imgHeight * (36 / 1024);
                        let fontPosX = i === 0 ?
                            (imgHeight * (935.1598173515982 / 1024)) :
                            (imgHeight * (1290.12 / 1024))
                        let fontPosY = imgHeight * (914.2857142857142 / 1024);

                        /* logo variables */
                        var logoPaddingX = imgHeight * (1280 / 1024);
                        var logoPaddingY = imgHeight * (20 / 1024);
                        var logoScaleX = imgHeight * (263.15789473684214 / 1024);
                        var logoScaleY = imgHeight * (60.26315789473684 / 1024);

                        if (i == 0) {
                            /* set canvas dimension */
                            canvas.width = imgHeight * (1591 / 1024);
                            canvas.height = imgHeight;

                            /* draw mask */
                            ctx.drawImage(mask, girlClipX, girlClipY, girlWidth, girlHeight, girlPosX, girlPosY, girlScaleX, girlScaleY);
                            ctx.globalCompositeOperation = 'source-out';

                            /* draw tag front */
                            ctx.drawImage(image, imageClipX, imageClipY, imgWidth, imgHeight, imagePosX, imagePosY, imageScaleX, imageScaleY);
                            ctx.globalCompositeOperation = 'destination-over';

                            /* draw girl */
                            ctx.drawImage(girl, girlClipX, girlClipY, girlWidth, girlHeight, girlPosX, girlPosY, girlScaleX, girlScaleY);

                            /* draw wall */
                            if (wall.width >= wall.height) {
                                var height = canvas.width * (wall.height / wall.width);
                                ctx.drawImage(wall, 0, 0, wall.width, wall.height, 0, 0, canvas.width, height);
                            } else {
                                var width = canvas.height * (wall.width / wall.height);
                                ctx.drawImage(wall, 0, 0, wall.width, wall.height, 0, 0, canvas.height, width);
                            }

                            ctx.globalCompositeOperation = 'source-over';

                            /* draw circle */
                            ctx.beginPath();
                            ctx.arc(circleX, circleY, circleRadius, 0, 2 * Math.PI);
                            ctx.fillStyle = 'white';
                            ctx.fill();

                            /* draw tag front */
                            ctx.drawImage(image, imageClipX, imageClipY, imgWidth, imgHeight, imagePosX * 3.7, imagePosY, imageScaleX, imageScaleY);
                        } else {
                            /* draw tag back */
                            ctx.drawImage(image, imageClipX, imageClipY, imgWidth, imgHeight, imagePosX * 5.35, imagePosY, imageScaleX, imageScaleY);
                        }

                        /* draw text */
                        ctx.font = fontSize + 'px ' + _this.props.pzDownloadCartImageFontFamily;
                        ctx.textAlign = "center";
                        ctx.fillStyle = "black";
                        ctx.fillText(viewNames[i], fontPosX, fontPosY);

                        /* draw logo */
                        i !== 0 && ctx.drawImage(logo, 0, 0, logo.width, logo.height, logoPaddingX, logoPaddingY, logoScaleX, logoScaleY);
                    }

                    /* draw watermark */
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var xCount = canvas.width / (imgHeight * (watermark.width / 1024)) + 1;
                var yCount = canvas.height / (imgHeight * (watermark.height / 1024)) + 1;
                ctx.globalAlpha = 0.2;
                for (var yIndex = 0; yIndex < yCount; yIndex++) {
                    for (var xIndex = 0; xIndex < xCount; xIndex++) {
                        ctx.drawImage(watermark, 0, 0, watermark.width, watermark.height, imgHeight * (watermark.width / 1024) * xIndex * 1.4, imgHeight * (watermark.height / 1024) * yIndex * 3, imgHeight * (watermark.width / 1024), imgHeight * (watermark.height / 1024));
                    }
                }

                /* download image */
                download.href = canvas.toDataURL("image/jpeg", 0.5);
                download.click();
            }
        };

        _this.pzShare = function () {
            _this.setState({
                showEmailPopUp: true
            });
            //let selectedValues = pzGetSelectedValues(this.props.pzCanvasObject, this.props.pzProductPrice)
            // pzSaveForLater(this.props).then((response) => {
            var editUrl = ''; //response;
            // this.setState({ showEmailPopUp: true, editUrl: editUrl, selectedValues: selectedValues })
            // })
        };

        _this.pzStartOverHandler = function () {
            _this.props.HomeComponent.setState({ pzDialogPopup: true });
        };

        _this.pzQuantityHandler = function (e, value) {
            e.preventDefault();
            var _this$props = _this.props,
                pzProductPrice = _this$props.pzProductPrice,
                pzQuantity = _this$props.pzQuantity;

            var price = pzQuantity ? parseFloat(pzProductPrice) / parseInt(pzQuantity) : parseFloat(pzProductPrice);
            pzProductPrice = value ? parseFloat(price) * parseFloat(value) : parseInt(e.target.value) > 0 ? parseFloat(price) * parseInt(e.target.value) : parseFloat(price);
            _this.props.HomeComponent.setState({ pzProductPrice: pzProductPrice, pzQuantity: value ? parseInt(value) : parseInt(e.target.value) <= _this.props.pzMinimumQuantity ? _this.props.pzMinimumQuantity : parseInt(e.target.value) });
        };

        _this.IncrementItem = function () {
            _this.setState(function (prevState) {
                if (prevState.quantity < _this.state.maxquantity) {
                    return {
                        quantity: prevState.quantity + 1 * _this.state.quantitymultiples
                    };
                } else {
                    return null;
                }
            });
        };

        _this.DecreaseItem = function () {
            _this.setState(function (prevState) {
                if (prevState.quantity > _this.state.minquantity) {
                    return {
                        quantity: prevState.quantity - 1 * _this.state.quantitymultiples
                    };
                } else {
                    return null;
                }
            });
        };

        _this.getPrice = function () {
            var isSilkScreen = false;
            if (_this.props.pzActiveOptions && Object.keys(_this.props.pzActiveOptions).length > 0) {
                for (var objKey in _this.props.pzActiveOptions) {
                    var currActionOptions = _this.props.pzActiveOptions[objKey];
                    var findIdx = currActionOptions.findIndex(function (element) {
                        return typeof element === "string" && element.indexOf('silkscreen') !== -1;
                    });
                    if (findIdx >= 0) {
                        isSilkScreen = true;
                        break;
                    }
                }
            }
            var pzCanvasObject = _this.props.pzCanvasObject;
            var finalPrice = 0;
            var innerObjInc = 0,
                outerObjInc = 0,
                twoSidedPrice = 0,
                twoSidedObjInc = 0;
            pzCanvasObject && Object.keys(pzCanvasObject).length > 0 && Object.keys(pzCanvasObject).map(function (objKey) {

                if (isSilkScreen) {
                    if (pzCanvasObject[objKey].customType == 'text' && pzCanvasObject[objKey].text || pzCanvasObject[objKey].customType == 'uploadimage' && pzCanvasObject[objKey].src) {
                        if (objKey.includes(_this.props.pzCopyOuterObjKeys[0]) || objKey.includes(_this.props.pzCopyOuterObjKeys[1])) {
                            if (pzCanvasObject[objKey].option_price) {
                                twoSidedPrice += pzCanvasObject[objKey].option_price;
                                outerObjInc++;
                            }
                        }
                        if (objKey.includes(_this.props.pzCopyInnerObjKeys[0]) || objKey.includes(_this.props.pzCopyInnerObjKeys[1])) {
                            if (pzCanvasObject[objKey].option_price) {
                                twoSidedPrice += pzCanvasObject[objKey].option_price;
                                innerObjInc++;
                            }
                        }
                    }
                }
                var priceField = pzCanvasObject[objKey].bulk_pricing;
                if (priceField) {
                    var currObjPrice = _this.props.HomeComponent.pzGetPriceList(priceField);
                    if (currObjPrice) {
                        finalPrice += currObjPrice;
                    }
                }
            });
            //console.log("innerObjInc ", innerObjInc, " outerObjInc ", outerObjInc, "twoSidedObjInc ", twoSidedObjInc)
            twoSidedObjInc = outerObjInc + innerObjInc;

            if (innerObjInc >= 1 && outerObjInc >= 1) {
                twoSidedPrice = parseFloat(twoSidedPrice) / parseInt(twoSidedObjInc);
            } else {
                twoSidedPrice = 0;
            }
            finalPrice = parseFloat(finalPrice) + parseFloat(twoSidedPrice);
            return finalPrice;
        };

        _this.state = {
            canvasurl: '',
            quantity: 1,
            minquantity: 1,
            maxquantity: 10000,
            quantitymultiples: 1,
            showEmailPopUp: false,
            editUrl: '',
            selectedValues: {}
        };
        return _this;
    }

    _createClass(PromizeCart, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(PZCart, _extends({}, this.props, this.state, { pzQuantityHandler: this.pzQuantityHandler, IncrementItem: this.IncrementItem, DecreaseItem: this.DecreaseItem, pzDownloadHandler: this.pzDownloadHandler, pzStartOverHandler: this.pzStartOverHandler, canvasurl: this.state.canvasurl, pzShare: this.pzShare, pzAddToCart: this.props.HomeComponent.pzAddToCart, getPrice: this.getPrice })),
                this.state.showEmailPopUp && React.createElement(PromizeMailShare, _extends({}, this.props, this.state, { cart: this }))
            );
        }
    }]);

    return PromizeCart;
}(React.Component);